import React, { useState } from 'react';
import { Lock } from 'lucide-react';

const API_BASE = import.meta.env.VITE_API_URL || '/api';
const field = 'w-full rounded border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 placeholder:text-slate-400 focus:outline-hidden focus:border-blue-500';

/**
 * "Request a Quote" form. In the editor preview (`slug` empty) it is inert.
 * @param {{slug?: string}} props
 */
export default function QuoteForm({ slug }) {
  const [f, setF] = useState({ name: '', email: '', phone: '', comments: '', consent: false });
  const [state, setState] = useState({ busy: false, done: false, error: '' });
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.type === 'checkbox' ? e.target.checked : e.target.value }));
  const live = !!slug;

  async function submit(e) {
    e.preventDefault();
    if (!live) return;
    setState({ busy: true, done: false, error: '' });
    try {
      const r = await fetch(`${API_BASE}/producer-page/public/${encodeURIComponent(slug)}/quote`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(f),
      });
      const data = await r.json().catch(() => ({}));
      if (!r.ok || !data.ok) throw new Error(data.error || 'Could not send your message.');
      setState({ busy: false, done: true, error: '' });
    } catch (err) {
      setState({ busy: false, done: false, error: err.message });
    }
  }

  if (state.done) {
    return <p className="text-sm text-emerald-700 font-medium py-6" role="status">Thank you! We'll get back to you as soon as possible.</p>;
  }

  return (
    <form onSubmit={submit} className="space-y-3 w-full" data-testid="quote-form">
      <input className={field} placeholder="Full Name *" value={f.name} onChange={set('name')} disabled={!live} required />
      <input className={field} placeholder="Email Address" type="email" value={f.email} onChange={set('email')} disabled={!live} />
      <input className={field} placeholder="Phone Number *" type="tel" value={f.phone} onChange={set('phone')} disabled={!live} required />
      <textarea className={`${field} h-24`} placeholder="Comments" value={f.comments} onChange={set('comments')} disabled={!live} />
      <label className="flex items-start gap-2 text-[11px] text-slate-600">
        <input type="checkbox" checked={f.consent} onChange={set('consent')} disabled={!live} className="mt-0.5" />
        <span>
          By checking, I accept Terms of Service &amp; Privacy Policy, and agree to be contacted by phone, text and email
          about insurance (including with automated technology). Consent is not a condition of purchase.
        </span>
      </label>
      {state.error && <p className="text-xs text-rose-600" role="alert">{state.error}</p>}
      <button type="submit" disabled={!live || state.busy || !f.consent} className="w-full rounded bg-blue-500 py-2 text-xs font-bold tracking-wide text-white disabled:opacity-60">
        {state.busy ? 'SENDING…' : 'SEND MESSAGE'}
      </button>
      <p className="flex items-center justify-center gap-1 text-[11px] text-slate-400"><Lock className="w-3 h-3" /> We respect your privacy.</p>
    </form>
  );
}
